import { default as Image } from '@react/shared/components/Image';
import { DynamicImageProps } from 'sly/hubPage/components/HubDynamicContent/DynamicImage/DynamicImage.types';

export default function DynamicImage({ image, size }: DynamicImageProps) {
  if (!image) {
    return null;
  }
  const { alternativeText, path } = image;
  const isFullSizeImage = size === 'large';
  let data = {
    tabletWidth: 0,
    laptopWidth: 0,
    width: isFullSizeImage ? 'w-full' : '',
    mediumWidth: '',
    largeWidth: '',
  };
  switch (size) {
    case 'middle':
      data = {
        tabletWidth: 680,
        laptopWidth: 1032,
        width: 'w-[calc(100%-2rem)]',
        mediumWidth: 'md:w-[var(--col8)]',
        largeWidth: 'lg:w-[var(--col12)]',
      };
      break;
    case 'small':
      data = {
        tabletWidth: 504,
        laptopWidth: 680,
        width: 'w-[calc(100%-2rem)]',
        mediumWidth: 'md:w-[var(--col6)]',
        largeWidth: 'lg:w-[var(--col8)]',
      };
      break;
  }
  const { tabletWidth, laptopWidth, width, mediumWidth, largeWidth } = data;
  const marginBottom = alternativeText ? 'mb-xs' : 'mb-xl';
  const mediumMarginBottom = alternativeText ? 'md:mb-m' : 'md:mb-xxl';
  return (
    <>
      <div
        className={`${marginBottom} mt-xs ${width} ${mediumWidth} ${mediumMarginBottom} md:mt-m ${largeWidth}`}
        data-tp-id='gen-div-1b2181a7-b806-408c-bea1-0b8f04eb4680'
      >
        <div
          className='relative h-0 w-full pt-[66%]'
          data-tp-id='gen-div-22dcb5ff-cb3e-482b-b8ea-57e634fedc12'
        >
          <Image
            path={path}
            layout='raw'
            width={400}
            height={400}
            className='absolute top-0 left-0 h-full w-full object-cover'
            alt={alternativeText || ''}
            sizes={
              isFullSizeImage
                ? '100vw'
                : `(max-width: 727px) 100vw, (max-width: 1079px) ${tabletWidth}px, ${laptopWidth}px`
            }
            data-tp-id='gen-Image-cf50655a-842a-4b61-95ae-7000081e2491'
          />
        </div>
      </div>
      {alternativeText && (
        <div
          className='font-b-s mb-xl w-[calc(100%-2rem)] text-center md:mb-xxl md:w-[var(--col6)] lg:w-[var(--col8)]'
          data-tp-id='gen-div-b926ef97-facf-4875-9e37-14574b3bd1a3'
        >
          {alternativeText}
        </div>
      )}
    </>
  );
}
